import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const StageStatusChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: 40, color: "#999" }}>
        No stage data available
      </div>
    );
  }

  // Each entry in `data` has: stage_name, total, jobs[]
  // We group jobs by status to build stacked bars
  const chartData = data.map((stage) => {
    const jobs = stage.jobs || [];
    const created = jobs.filter((j) => j.status === "created").length;
    const scheduled = jobs.filter((j) => j.status === "scheduled").length;
    const inProgress = jobs.filter(
      (j) => j.status === "in_progress" || j.status === "running"
    ).length;
    const completed = jobs.filter((j) => j.status === "completed").length;

    // Capitalize stage name for display
    const name = stage.stage_name
      .replace(/_/g, " ")
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    return {
      name,
      Created: created,
      Scheduled: scheduled,
      "In Progress": inProgress,
      Completed: completed,
      Total: stage.total,
    };
  });

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={chartData}
        layout="vertical"
        margin={{ top: 10, right: 30, left: 100, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis type="category" dataKey="name" width={90} />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="Created"
          stackId="a"
          fill="#bfbfbf"
          name="Created"
        />
        <Bar
          dataKey="Scheduled"
          stackId="a"
          fill="#faad14"
          name="Scheduled"
        />
        <Bar
          dataKey="In Progress"
          stackId="a"
          fill="#1890ff"
          name="In Progress"
        />
        <Bar
          dataKey="Completed"
          stackId="a"
          fill="#52c41a"
          name="Completed"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StageStatusChart;
